// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface DetailPageHeaderFieldProps {
  label: ReactNode;
  /**
   * Render the value as-is instead of wrapping it in the standard `body2`
   * Typography, for values that provide their own typography (e.g. an
   * editable property control)
   */
  disableValueTypography?: boolean;
  children: ReactNode;
}

export function DetailPageHeaderField(props: DetailPageHeaderFieldProps) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="subtitle2" color="text.secondary">
        {props.label}:
      </Typography>
      {props.disableValueTypography ? (
        props.children
      ) : (
        <Typography variant="body2">{props.children}</Typography>
      )}
    </Stack>
  );
}
